<template>
    <div class="modal fade" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="loginModalLabel">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-2 col-md-offset-1">
                            <img src="../../assets/valkyrie_logo_head.png" width="50px">
                        </div>
                        <div class="col-md-offset-1 col-md-8">
                            <p id="login-modal-title">Valkyrie Threat <br/>Intelligence</p>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <input class="login-input" type="text" placeholder="USER NAME"/>
                    </div>
                    <hr class="small-hr">
                    <div class="row">
                        <input class="login-input" type="text" placeholder="PASSWORD"/>
                    </div>
                    <hr class="small-hr">
                    <div class="row">
                        <div class="col-md-3"></div>
                        <div class="col-md-6">
                            <button class="login-button">LOGIN</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "login-modal",
        methods: {
            showModal() {
                $('#loginModal').modal('show');
            },
            hideModal() {
                $('#loginModal').modal('hide');
            }
        },
        mounted() {
            $('#loginModal').modal({show: false});
        }
    }
</script>

<style scoped>

    .login-button {
        font-family : 'Digital-Serial-Bold';
        padding: 5px 15px;
        background-color: rgba(0, 255, 169, 1);
        border: 1px solid rgba(0, 255, 169, 1);
        border-radius: 2px;
        font-size: 1.5em;
        color: rgba(52, 63, 73, 1);
        cursor: pointer;
        width: 100%;
    }

    .login-input {
        background-color: transparent;
        color: rgba(0, 255, 169, 1);
        font-family : 'Digital-Serial-Regular';
        font-size: 1em;
        text-align: center;
        border: none;
        width: 100%;
    }

    .login-input::placeholder {
        color: rgba(0, 255, 169, 1);
        font-family : 'Digital-Serial-Regular';
    }

    hr {
        display: block;
        height: 1px;
        border: 0;
        border-top: 1px solid rgba(0, 255, 169, 0.3);
        margin: 1em 0;
        padding: 0;
    }

    .small-hr {
        margin-left: 10%;
        margin-right: 10%;
    }

    #login-modal-title {
        font-family : 'Digital-Serial-Regular';
        font-size: 1.5em;
        color: rgba(0, 255, 169, 1);
        text-shadow: 0em 0em 0.375em rgba(0, 255, 169, 1);
        padding-top: 15px;
    }

    .modal {
        text-align: center;
    }

    @media screen and (min-width: 768px) {
        .modal:before {
            display: inline-block;
            vertical-align: middle;
            content: " ";
            height: 100%;
        }
    }

    .modal-dialog {
        display: inline-block;
        text-align: left;
        vertical-align: middle;
    }

    .modal-content {
        border-radius: 4px;
        overflow: hidden;
        background-color: transparent;
    }

    .modal-dialog {
        background-color: transparent;
    }

    .modal-header, .modal-body, .modal-footer {
        background-color: #1C2328;
    }

</style>



// WEBPACK FOOTER //
// src/components/modals/LoginModal.vue